import { isEqual } from 'lodash';
import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';
import { booleanPreferenceSelector } from '../../auth/selectors/auth.selectors';
import { EMPTY_COMMENT } from '../types/diagnostic';
import { separateAbnormalities } from '../utils/abnormalities.util';

export const userDiagnosticSelector = ({ userDiagnostic }: DefaultRootState) =>
  userDiagnostic;

export const baseDiagnosticSelector = createSelector(
  userDiagnosticSelector,
  ({ baseDiagnostic }) => baseDiagnostic,
);

export const editableDiagnosticSelector = createSelector(
  userDiagnosticSelector,
  ({ editableDiagnostic }) => editableDiagnostic,
);

export const commentSelector = createSelector(
  editableDiagnosticSelector,
  ({ comment }) => (comment === EMPTY_COMMENT ? '' : comment),
);

export const primaryAbnormalitiesSelector = createSelector(
  editableDiagnosticSelector,
  booleanPreferenceSelector('autoDiagnostic'),
  ({ abnormalities }, hasAutoDiagnostic) =>
    hasAutoDiagnostic ? separateAbnormalities(abnormalities)[0] : [],
);

export const manualAbnormalitiesSelector = createSelector(
  editableDiagnosticSelector,
  booleanPreferenceSelector('autoDiagnostic'),
  ({ abnormalities }, hasAutoDiagnostic) =>
    hasAutoDiagnostic ? separateAbnormalities(abnormalities)[1] : abnormalities,
);

export const allAbnormalitiesSelector = createSelector(
  editableDiagnosticSelector,
  ({ abnormalities }) => abnormalities,
);

export const diagnosticChangedSelector = createSelector(
  baseDiagnosticSelector,
  editableDiagnosticSelector,
  (active, editable) => !isEqual(active, editable),
);

export const suggestionsLogsSelector = createSelector(
  editableDiagnosticSelector,
  ({ suggestionsLogs }) => suggestionsLogs,
);
